import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { AppDispatch } from '../../store'
import { resetChanges } from '../../store/changes/changesSlice'
import useBlocker from '../useBlocker'

const useCallbackPrompt = (when: boolean, doSomeCancelLogic: any, doSomeConfirmLogic: any) => {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const location = useLocation()
  const [showPrompt, setShowPrompt] = useState(false)
  const [lastLocation, setLastLocation] = useState<any>(null)
  const [confirmedNavigation, setConfirmedNavigation] = useState(false)

  const cancelNavigation = useCallback(() => {
    doSomeCancelLogic()
    setShowPrompt(false)
    setConfirmedNavigation(true)
  }, [])

  // handle blocking when user click on another route prompt will be shown
  const handleBlockedNavigation = useCallback(
    (nextLocation: { location: { pathname: string } }) => {
      // in if condition we are checking next location and current location are equals or not
      if (!confirmedNavigation && nextLocation.location.pathname !== location.pathname) {
        setShowPrompt(true)
        setLastLocation(nextLocation)
        return false
      }
      return true
    },
    [confirmedNavigation, location],
  )

  const confirmNavigation = useCallback(() => {
    doSomeConfirmLogic()
    setShowPrompt(false)
    setConfirmedNavigation(true)
    dispatch(resetChanges())
  }, [])

  const justClosePrompt = useCallback(() => {
    setShowPrompt(false)
  }, [])

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      navigate(lastLocation.location?.pathname)

      // Clean-up state on confirmed navigation
      setConfirmedNavigation(false)
    }
  }, [confirmedNavigation, lastLocation])

  useBlocker(handleBlockedNavigation, when)

  return [showPrompt, confirmNavigation, cancelNavigation, justClosePrompt]
}

export default useCallbackPrompt
